import { createStore } from "vuex";
export default createStore({
  state:
      {
        base_urls:
            {
              // adminsUploads:'https://localhost/core/storage/adminsUploads/',
              // officialUploads:'https://localhost/core/storage/officialUploads/',
              // messagesUploads:'https://localhost/core/storage/messagesUploads/',
              // postsUploads:'https://localhost/core/storage/postsUploads/',
              // webUploads:'https://localhost/core/storage/webUploads/',
              adminsUploads:'https://dl.canada-az-iran.com/storage/adminsUploads/',
              officialUploads:'https://dl.canada-az-iran.com/storage/officialUploads/',
              messagesUploads:'https://dl.canada-az-iran.com/storage/messagesUploads/',
              postsUploads:'https://dl.canada-az-iran.com/storage/postsUploads/',
              webUploads:'https://dl.canada-az-iran.com/storage/webUploads/',
            },
          expertDetail:null,
          alongExpertDetail:null,
          notificationDetails :
              {
                  show:false,
                  unreadMessagesCount:0
              },
          socialMediaLinks:
              {
                  telegram:null,
                  instagram:null,
              },
          loginStatus:true,
          preliminaryReview:false,
          accountPage:false,
          authenticationPage:false,
          userPanelPage:false,
          groupsIds:null
      },
  mutations: {},
  actions: {},
  modules: {}
});
